import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PageMetaLoader from '../components/PageMetaLoader';

const SolutionsPage = () => {
  const publicUrl = process.env.PUBLIC_URL || '';

  const solutions = [
    {
      title: 'Sales',
      description: 'Create and send online quotations and invoices, track sales, monitor staff performance, and sell & sync all your products via our Point of Sales (POS), and Ecommerce store.',
      image: `${publicUrl}/images/solutions/sales-solution.jpg`,
      link: '/solutions/sales'
    },
    
    {
      title: 'HR',
      description: 'Set up your organizational structure, add employees, create contracts, manage employees\' shifts, attendance, payroll and more.',
      image: `${publicUrl}/images/solutions/hr-solution.jpg`,
      link: '/products/hrms'
    },
    {
      title: 'Inventory',
      description: 'Add unlimited products, control different warehouses, issue purchase orders to your suppliers, follow them with ease and more.',
      image: `${publicUrl}/images/solutions/inventory-solution.jpg`,
      link: '/solutions/inventory'
    },
    {
      title: 'CRM',
      description: 'Create clients profiles, add notes, attach files, schedule appointments, reservations, follow up calls/emails or delivery easily and more.',
      image: `${publicUrl}/images/solutions/crm-solution.jpg`,
      link: '/products/crm'
    },
    {
      title: 'Accounting',
      description: 'Manage your cash flow, purchases, taxes, profit & loss, balance sheet, sales, chart of accounts, income statement, assets and more.',
      image: `${publicUrl}/images/solutions/accounting-solution.jpg`,
      link: '/products/crm'
    }, {
      title: 'Clinic Management',
      description: 'Manage your clinic appointments, patients, staff, inventory, and more.',
      image: `${publicUrl}/images/products/clinic-bg.gif`,
      link: '/products/clinic'
    },
  ];

  return (
    <>
    <PageMetaLoader pageUrl="solutions" />
    <SolutionsContainer>
      <PageTitle>Our Solutions</PageTitle>
      <SolutionsGrid>
        {solutions.map((solution, index) => (
          <SolutionCard key={index}>
            <SolutionImage>
              <img src={solution.image} alt={solution.title} />
            </SolutionImage>
            <SolutionContent>
              <h3>{solution.title}</h3>
              <SolutionDescription>{solution.description}</SolutionDescription>
              <SolutionLink to={solution.link}>Learn More</SolutionLink>
            </SolutionContent>
          </SolutionCard>
        ))}
      </SolutionsGrid>
    </SolutionsContainer>
    </>
  );
};

const SolutionsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 3rem;
`;

const SolutionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
`;

const SolutionCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const SolutionImage = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const SolutionContent = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.5rem;
    color: var(--primary-color);
    margin-bottom: 1rem;
  }

  p {
    color: var(--text-dark);
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
`;

const SolutionDescription = styled.div`
  color: var(--text-color);
 margin-bottom: 1.5rem;
`;

const SolutionLink = styled(Link)`
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--accent-color);
  }
`;

export default SolutionsPage; 